import { createFileRoute, Link, Outlet, useMatch } from '@tanstack/react-router';
import { Footer } from './-components/footer';
import { Header } from './-components/header';
import { DivWithPrimaryColorVariable } from './-components/div-with-primary-color-variable';
import { Progress } from '@worldcoo/ui/components/progress';
import { ChevronLeftIcon } from 'lucide-react';
import { useTranslation } from '@/lib/i18n';
import { portalCampaignMetadataOptions, portalMetadataOptions } from '@/lib/queries';

export const Route = createFileRoute('/$portalId/$campaignId/donate')({
	loader: ({ context, params }) => {
		context.queryClient.ensureQueryData(
			portalMetadataOptions({
				locale: context.locale,
				portalId: context.portalId,
			}),
		);

		context.queryClient.ensureQueryData(
			portalCampaignMetadataOptions({
				locale: context.locale,
				portalId: context.portalId,
				campaignId: params.campaignId,
			}),
		);
	},
	component: Component,
});

function Component() {
	const { portalId, campaignId } = Route.useParams();
	const { i18n } = useTranslation();
	const donatePage = useMatch({ from: '/$portalId/$campaignId/donate/', shouldThrow: false });
	const donateDetailsPage = useMatch({ from: '/$portalId/$campaignId/donate/details', shouldThrow: false });

	const backToLink = donatePage
		? '/$portalId/$campaignId'
		: donateDetailsPage
			? '/$portalId/$campaignId/donate'
			: '/$portalId/$campaignId/donate/details';

	return (
		<>
			<Header />
			<DivWithPrimaryColorVariable className="bg-secondary flex-1">
				<nav className="mx-auto w-full max-w-[1366px]">
					<Link
						to={backToLink}
						params={{ portalId, campaignId }}
						search={(prev) => prev}
						className="flex w-fit items-center gap-2 p-6"
					>
						<ChevronLeftIcon />
						{i18n.actions.previous}
					</Link>
				</nav>

				<div className="px-6 pb-20">
					<section className="bg-background shadow-4xl mx-auto flex w-full max-w-xl flex-col gap-8 rounded-xl p-12">
						<DonationProgress />
						<Outlet />
					</section>
				</div>
			</DivWithPrimaryColorVariable>
			<Footer />
		</>
	);
}

function DonationProgress() {
	const donatePage = useMatch({ from: '/$portalId/$campaignId/donate/', shouldThrow: false });
	const donateDetailsPage = useMatch({ from: '/$portalId/$campaignId/donate/details', shouldThrow: false });

	return <Progress className="mx-auto h-1 max-w-50" value={((donatePage ? 1 : donateDetailsPage ? 2 : 3) / 3) * 100} />;
}
